import { render, staticRenderFns } from "./OneOnOneManager.vue?vue&type=template&id=0b30ec4a&scoped=true"
import script from "./OneOnOneManager.vue?vue&type=script&lang=js"
export * from "./OneOnOneManager.vue?vue&type=script&lang=js"
import style0 from "./OneOnOneManager.vue?vue&type=style&index=0&id=0b30ec4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30ec4a",
  null
  
)

export default component.exports